import React from 'react';
import './PickPayment.scss';
import { Divider } from 'antd';
import Checkbox from 'Components/Shared/Checkbox/Checkbox';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText, { IFormattedText } from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  name: string;
  text: string;
  price: number;
  isSelected: boolean;
  onPaymentItemChange: (paymentName: string, isChecked: boolean) => void;
}

const PaymentItem: React.SFC<IProps> = ({
  name,
  text = '',
  price,
  isSelected,
  onPaymentItemChange,
}) => {

  const onChange = (isChecked: boolean) => {
    onPaymentItemChange(name, isChecked);
  };

  return (
    <>
      <Divider />
      <Checkbox style='payment-item' onChange={ onChange } value={ isSelected }>
        <span className='medium-bold'>{ name }</span>
        { price > 0 ?
          <div>
            <PriceItem price={ price } decimals={ 2 } />
            { `. ${ text } ` }
          </div> :
          <div>
            <FormattedText
              displayName='Ingen avgift'
              formattedName='global.pricefree'
            />
            (<PriceItem price={ price } decimals={ 2 } />)
            { `. ${ text } ` }
          </div>
        }
      </Checkbox>
    </>
  );
}

export default PaymentItem;


// WEBPACK FOOTER //
// ./src/components/PickPayment/PaymentItem.tsx